import { IntentsState } from '.';
import { GetterTree } from 'vuex';
import { AppState } from '../app';
import { IntentListItemViewModel } from '@/features/bots/models/intents/intentListItemViewModel';

export const getters: GetterTree<IntentsState, AppState> = {
  intents(state: IntentsState): IntentListItemViewModel[] {
    return state.intents;
  },
  getIntentName(state: IntentsState) {
    return (intentId: string) => {
      return state.intents.find((intent) => intent.id === intentId)?.title;
    };
  },
};
